module.exports = __webpack_public_path__ + "img/h-heyerlein-BsWgMBfb208-unsplash.7e7569b6.jpg";